export default __webpack_public_path__ + "static/media/Bossonian Charm.d251b77c.jpg";